<style lang="scss">
@import '$vars';

.fields {
  &.modal-container {
    max-width: 700px !important;
  }

  box-sizing: border-box;

  &__header.modal-header {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0;
    padding: 20px 10px;
  }

  &__description {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }

  &__title {
    box-sizing: border-box;
    display: block;
    margin: 0 0 5px 0;
  }

  &__subtitle {
    box-sizing: border-box;
    color: #4A4A4A;
    display: block;
    font-size: 0.8rem;
    font-weight: 500;
    margin-bottom: 0;
  }

  &__wrapper.modal-body {
    box-sizing: border-box;
    margin: 10px 10px 10px;
    padding: 0;
  }

  &__list {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    flex: 0 calc(100% / 3 - 10px);
    padding: 10px;
    margin: 0 5px 20px 5px;

    &:hover {
     background-color: #DEE1E2;
    }

    &--active {
      background-color: darken(#DEE1E2, 5%);
    }

    span {
      display: block;
      font-size: 0.75rem;
      font-weight: 500;
      margin-bottom: 10px;
    }
  }
}
</style>

<template>
  <section class="fields modal modal-md2 active">
    <a class="modal-overlay" aria-label="Close" @click="close()"></a>

    <article class="modal-container fields">
      <header class="modal-header fields__header">
        <div class="fields__description">
          <h5 class="fields__title">Adicionar novo campo</h5>
          <p class="fields__subtitle">Escolha abaixo o tipo de campo que deseja adicionar</p>
        </div>

        <a class="btn btn-clear" aria-label="Close" @click="close()"></a>
      </header>

      <div class="modal-body fields__wrapper">
        <ul class="fields__list">
          <li
            class="fields__item"
            v-for="(field, index) in fieldTypes"
            @click="selectedType = field.type"
            :key="`field_${index}`"
            :class="(selectedType === field.type) ? 'fields__item--active' : ''"
          >
            <span>{{ field.name }}</span>
            <img :src="field.img">
          </li>
        </ul>
      </div>

      <footer class="modal-footer">
        <button
          class="btn btn-primary btn-md"
          :disabled="!selectedType"
          @click="addField"
        >
          Adicionar
        </button>
      </footer>
    </article>
  </section>
</template>

<script>
import imgDate from '@/assets/img/anamnesis/anamnesis_field_date.png'
import imgText from '@/assets/img/anamnesis/anamnesis_field_text.png'
import imgRadio from '@/assets/img/anamnesis/anamnesis_field_radio.png'
import imgNumber from '@/assets/img/anamnesis/anamnesis_field_number.png'
import imgSelect from '@/assets/img/anamnesis/anamnesis_field_select.png'
import imgTextarea from '@/assets/img/anamnesis/anamnesis_field_textarea.png'
import imgCheckboxes from '@/assets/img/anamnesis/anamnesis_field_checkboxes.png'

export default {
  name: 'DrAnamnesisDetailsFields',

  data () {
    return {
      selectedType: null,
      fieldTypes: [
        {
          name: 'Campo de texto',
          type: 'text',
          img: imgText
        },
        {
          name: 'Texto longo',
          type: 'textarea',
          img: imgTextarea
        },
        {
          name: 'Campo numérico',
          type: 'number',
          img: imgNumber
        },
        {
          name: 'Lista',
          type: 'select',
          img: imgSelect
        },
        {
          name: 'Múltipla escolha',
          type: 'checkbox',
          img: imgCheckboxes
        },
        {
          name: 'Escolha única',
          type: 'radio',
          img: imgRadio
        },
        {
          name: 'Data',
          type: 'date',
          img: imgDate
        }
      ]
    }
  },
  computed: {
    selectedTypeObject () {
      const object = this.fieldTypes.filter(field => field.type === this.selectedType)
      return {
        name: object[0].name,
        type: object[0].type
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    addField () {
      this.$emit('addField', this.selectedTypeObject)
      this.selectedType = null
      this.close()
    }
  }
}
</script>
